import React from "react";

import SweepstakesGoogleTag from "../SweepstakesGoogleTag";
import * as UI from "../Page/ui";
import Header from "./Header";
import Footer from "../Footer";
import SuperFooter from "../SuperFooter";

const Page = ({ children, greeting, sweepstakes, authToken, setAuthToken }) => (
  <React.Fragment>
    <SweepstakesGoogleTag />
    <UI.Layout>
      <Header greeting={greeting} authToken={authToken} setAuthToken={setAuthToken} />
      <UI.Body>{children}</UI.Body>
      {sweepstakes && <SuperFooter sweepstakes={sweepstakes} />}
      <Footer />
    </UI.Layout>
  </React.Fragment>
);

export default Page;
